module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"copy":"Copy","done":"Filled","submit":"Fill weights","title":"Article topics"}}')
  delete Component.options._Ctor
}
